import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0B1121] border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-8">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-xl font-heading font-bold text-primary uppercase tracking-wider">
              UAV Geo Solutions
            </h3>
            <p className="text-sm text-gray-400 font-light leading-relaxed">
              Transforming Institutions into Future-Ready Technology Centers
            </p>
            <div className="space-y-2">
              <p className="text-xs text-gray-500">CIN: U95120BR2024OPC066916</p>
              <p className="text-xs text-gray-500">GST: 10AADCU4826A1Z0</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-400 hover:text-primary transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/store" className="text-sm text-gray-400 hover:text-primary transition-colors">
                  Store
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-sm text-gray-400 hover:text-primary transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-gray-400 hover:text-primary transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-400 hover:text-primary transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Services
            </h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Robotics & IoT Labs</li>
              <li>Drone Lab Setup</li>
              <li>DGCA RPTO</li>
              <li>3D Printing Labs</li>
              <li>AR/VR/AI Labs</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm text-gray-400">
                <MapPin size={16} className="text-primary mt-1 flex-shrink-0" />
                <span>02B, Third Floor, Sector P3, Greater Noida – 201315</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-gray-400">
                <Mail size={16} className="text-primary flex-shrink-0" />
                <a href="mailto:Uavgeosolutions@gmail.com" className="hover:text-primary transition-colors">
                  Uavgeosolutions@gmail.com
                </a>
              </li>
              <li className="flex items-center space-x-2 text-sm text-gray-400">
                <Phone size={16} className="text-primary flex-shrink-0" />
                <div className="flex flex-col">
                  <a href="tel:+919693809074" className="hover:text-primary transition-colors">
                    +91 9693809074
                  </a>
                  <a href="tel:+919958831758" className="hover:text-primary transition-colors">
                    +91 9958831758
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} UAV Geo Solutions (OPC) Private Limited. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-sm text-gray-500 hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-gray-500 hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
